import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		current: {
			characterId: 'P',
			primaryWeapon: 0,
			secondaryWeapon: 4,
		},
		settings: {
			showExtraData: false,
			showUnplayableCharacters: false,
		}
	},
	getters: {
		getCharacterId( state )
		{
			return state.current.characterId;
		},
		getPrimaryWeapon( state )
		{
			return state.current.primaryWeapon;
		},
		getSecondaryWeapon( state )
		{
			return state.current.secondaryWeapon;
		},
		getShowExtraData( state )
		{
			return state.settings.showExtraData;
		},
		getShowUnplayableCharacters( state )
		{
			return state.settings.showUnplayableCharacters;
		},
	},
	mutations: {
		setCharacterId( state, characterId )
		{
			state.current.characterId = characterId;
		},
		setPrimaryWeapon( state, wpnIndex )
		{
			state.current.primaryWeapon = wpnIndex;
		},
		setSecondaryWeapon( state, wpnIndex )
		{
			state.current.secondaryWeapon = wpnIndex;
		},
		setShowExtraData( state, val )
		{
			state.settings.showExtraData = val;
		},
		setShowUnplayableCharacters( state, val )
		{
			state.settings.showUnplayableCharacters = val;
		},
	},
	actions: {},
	modules: {}
})
